import { PRIMARY_COLOR } from './style';

/**
 * 审核状态
 */
export enum AuditStatusType {
  STATUS_TYPE_DEFAULT = 0, // 创作中
  STATUS_TYPE_MANUAL_ING = 1, // 审核中
  STATUS_TYPE_MANUAL_FAIL = 2, // 审核不通过
  STATUS_TYPE_MANUAL_PASS = 3, // 审核通过
  STATUS_TYPE_MANUAL_OFFLINE = 4, // 下架
}

export enum AuditStatusDetailType {
  STATUS_DETAIL_TYPE_DEFAULT = 0, // 编辑中
  STATUS_DETAIL_TYPE_MANUAL_ING = 1, // 安审中
  STATUS_DETAIL_TYPE_MANUAL_FAIL = 2, // 安审失败
  STATUS_DETAIL_TYPE_MANUAL_PASS = 3, // 安审通过
  STATUS_DETAIL_TYPE_MANUAL_REVIEW_ING = 4, // 复审中
  STATUS_DETAIL_TYPE_MANUAL_REVIEW_FAIL = 5, // 复审失败
  STATUS_DETAIL_TYPE_MANUAL_REVIEW_PASS = 6, // 复审通过
  STATUS_DETAIL_TYPE_MANUAL_RESOURCE_PROCESSING = 7, // 资源处理中
  STATUS_DETAIL_TYPE_MANUAL_RESOURCE_PROCESS_FINISHED = 8, // 资源处理完成
  STATUS_DETAIL_TYPE_MANUAL_ONLINE = 10, // 上架
  STATUS_DETAIL_TYPE_MANUAL_OFFLINE = 11, // 下架--后续功能，本期暂不实现
}

export enum BotAuditStatusDetailType {
  STATUS_DETAIL_TYPE_DEFAULT = 0, // 编辑中
  STATUS_DETAIL_TYPE_MANUAL_ING = 1, // 安审中
  STATUS_DETAIL_TYPE_MANUAL_FAIL = 2, // 安审失败
  STATUS_DETAIL_TYPE_MANUAL_ONLINE = 3, // 上架
  STATUS_DETAIL_TYPE_MANUAL_OFFLINE = 4, // 下架
}

export const AuditStatusTypeListText = {
  [AuditStatusType.STATUS_TYPE_DEFAULT]: '创作中',
  [AuditStatusType.STATUS_TYPE_MANUAL_ING]: '审核中',
  [AuditStatusType.STATUS_TYPE_MANUAL_FAIL]: '审核不通过',
  [AuditStatusType.STATUS_TYPE_MANUAL_PASS]: '已上架',
  [AuditStatusType.STATUS_TYPE_MANUAL_OFFLINE]: '已下架',
};

export const AuditDetailStatusTypeListText = {
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_DEFAULT]: '创作中',
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_ING]: '安审中',
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_FAIL]: '安审失败',
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_PASS]: '安审通过',
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_REVIEW_ING]: '复审中',
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_REVIEW_FAIL]: '复审失败',
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_REVIEW_PASS]: '复审通过',
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_RESOURCE_PROCESSING]: '资源处理中',
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_RESOURCE_PROCESS_FINISHED]: '资源处理完成',
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_ONLINE]: '已上架',
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_OFFLINE]: '已下架',
};

export const BotAuditDetailStatusTypeListText = {
  [BotAuditStatusDetailType.STATUS_DETAIL_TYPE_DEFAULT]: '创作中',
  [BotAuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_ING]: '安审中',
  [BotAuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_FAIL]: '安审失败',
  [BotAuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_ONLINE]: '已上架',
  [BotAuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_OFFLINE]: '已下架',
};

export enum PayAuditStatusType {
  PAY_AUDIT_STATUS_DEFAULT = 0,
  PAY_AUDIT_STATUS_ING = 1,
  PAY_AUDIT_STATUS_FAIL = 2,
  PAY_AUDIT_STATUS_SUCCESS = 3,
  PAY_AUDIT_STATUS_PUBLISH = 4,
}

export const PayAuditStatusText = {
  [PayAuditStatusType.PAY_AUDIT_STATUS_DEFAULT]: {
    label: '编辑中',
    color: PRIMARY_COLOR,
  },
  [PayAuditStatusType.PAY_AUDIT_STATUS_ING]: {
    label: '审核中',
    color: 'rgba(123, 97, 255, 1)',
  },
  [PayAuditStatusType.PAY_AUDIT_STATUS_FAIL]: {
    label: '审核不通过',
    color: 'rgba(204, 73, 51, 1)',
  },
  [PayAuditStatusType.PAY_AUDIT_STATUS_SUCCESS]: {
    label: '审核通过',
    color: 'rgba(51, 178, 108, 1)',
  },
  [PayAuditStatusType.PAY_AUDIT_STATUS_PUBLISH]: {
    label: '已发布',
    color: 'rgba(41, 167, 142, 1)',
  },
};
